import type { FunctionComponent } from 'react';
import React, { useState } from 'react';
import styled from 'styled-components';
import Container from '@material-ui/core/Container';

import type { AppData } from '../../../../types/app_data';
import { trackEvent } from '../../../../utils/analytics';
import { JERRY_PHONE_URL } from '../../../../utils/url';

import { HelpButton } from './components/help_button/HelpButton';
import { HelpModal } from './components/help_modal/HelpModal';
import { HeaderLogo } from './components/HeaderLogo/HeaderLogo';
import PhoneSvg from './assets/phone.svg';

export interface TopNavProps {
  appData: AppData;
  className?: string;
  jerryLogoGrey?: boolean;
  subHeaderText?: string;
  partnerLogo?: JSX.Element;
  logosSameLine?: boolean;
  mainPartnerLogo?: boolean;
  topNavbackgroundWhite?: boolean;
  showCallJerry?: boolean;
}

/**
 * Top nav bar with logo and menu.
 */
const UnstyledTopNav: FunctionComponent<TopNavProps> = ({
  appData,
  className,
  jerryLogoGrey,
  subHeaderText,
  partnerLogo,
  logosSameLine,
  mainPartnerLogo,
  topNavbackgroundWhite,
  showCallJerry,
}) => {
  const hideRightTopButton = !!appData.flowType;
  const [open, setOpen] = useState(false);
  return (
    <>
      <Container maxWidth="xl" className={className}>
        <HeaderLogo
          jerryLogoGrey={jerryLogoGrey}
          subHeaderText={subHeaderText}
          partnerLogo={partnerLogo}
          logosSameLine={logosSameLine}
          mainPartnerLogo={mainPartnerLogo}
        />
        {!hideRightTopButton && !showCallJerry && (
          <HelpButton
            className="helpButton"
            topNavbackgroundWhite={topNavbackgroundWhite}
            onClick={() => {
              setOpen(!open);
            }}
          />
        )}
        {!hideRightTopButton && !!showCallJerry && (
          <a
            href={JERRY_PHONE_URL}
            onClick={() => {
              void trackEvent('FinishContactJerry', { eventLabel: 'Navigation' });
            }}
            className="phoneCallButton"
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={PhoneSvg} alt="" />
          </a>
        )}
      </Container>

      {!showCallJerry && (
        <HelpModal
          appData={appData}
          open={open}
          onClose={() => {
            setOpen(false);
          }}
        />
      )}
    </>
  );
};

export const TopNav = styled(UnstyledTopNav)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  background-color: ${({ topNavbackgroundWhite }) => topNavbackgroundWhite && '#ffffff;'};
  @media (max-width: ${({ theme }) => theme.breakpoints.ipad}px) {
    height: 62px;
  }
  .phoneCallButton {
    font-size: 0;
  }
`;
